import { useEffect, useState } from 'react';
import { api, getDeviceId } from './api';

const KEY_PROVIDER = 'unmanip_provider';
const KEY_MODEL = 'unmanip_model';

// Curated recommended models — the picker exposes these plus 'all' listing from API.
export const CURATED = [
  { provider: 'gemini',    model: 'gemini-3.1-pro-preview',       label: 'Gemini 3.1 Pro',        tag: 'default · multimodal' },
  { provider: 'gemini',    model: 'gemini-3.8-flash',             label: 'Gemini 3.8 Flash',      tag: 'newest · fast' },
  { provider: 'gemini',    model: 'gemini-3-flash-preview',       label: 'Gemini 3 Flash',        tag: 'fast' },
  { provider: 'gemini',    model: 'gemini-2.5-pro',               label: 'Gemini 2.5 Pro',        tag: 'grounded search' },
  { provider: 'openai',    model: 'gpt-6-sol',                    label: 'ChatGPT · GPT‑6 Sol',   tag: 'flagship' },
  { provider: 'openai',    model: 'gpt-5.6-terra',                label: 'ChatGPT · 5.6 Terra',   tag: 'reasoning' },
  { provider: 'openai',    model: 'gpt-5.4',                      label: 'ChatGPT · GPT‑5.4',     tag: 'balanced' },
  { provider: 'openai',    model: 'gpt-5.4-mini',                 label: 'ChatGPT · 5.4 Mini',    tag: 'fastest · cheap' },
  { provider: 'anthropic', model: 'claude-sonnet-5-5',            label: 'Claude Sonnet 5.5',     tag: 'nuance' },
  { provider: 'anthropic', model: 'claude-opus-5',               label: 'Claude Opus 5',         tag: 'deepest read' },
  { provider: 'anthropic', model: 'claude-haiku-4-5-20251001',    label: 'Claude Haiku 4.5',      tag: 'quick' },
];

export function getModelChoice() {
  return {
    provider: localStorage.getItem(KEY_PROVIDER) || 'gemini',
    model: localStorage.getItem(KEY_MODEL) || 'gemini-3.1-pro-preview',
  };
}

export function setModelChoice(provider, model) {
  localStorage.setItem(KEY_PROVIDER, provider);
  localStorage.setItem(KEY_MODEL, model);
  // update every axios request going forward
  api.defaults.headers['X-Model-Provider'] = provider;
  api.defaults.headers['X-Model-Name'] = model;
  window.dispatchEvent(new CustomEvent('unmanip:model', { detail: { provider, model } }));
}

export function useModelChoice() {
  const [choice, setChoice] = useState(getModelChoice);
  useEffect(() => {
    const onChange = (e) => setChoice(e.detail);
    window.addEventListener('unmanip:model', onChange);
    return () => window.removeEventListener('unmanip:model', onChange);
  }, []);
  return [choice, (p, m) => { setModelChoice(p, m); setChoice({ provider: p, model: m }); }];
}

// Attach current choice to every request as headers.
export function initModelHeaders() {
  const { provider, model } = getModelChoice();
  api.defaults.headers['X-Model-Provider'] = provider;
  api.defaults.headers['X-Model-Name'] = model;
  api.defaults.headers['X-Device-Id'] = getDeviceId();
}
